import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row g-3 mb-3" }
const _hoisted_2 = { class: "col-md-7" }
const _hoisted_3 = { class: "col-md-5" }
const _hoisted_4 = { class: "row g-3 mb-3" }
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = { class: "col-md-8" }
const _hoisted_7 = { class: "form-check d-flex align-items-center gap-2 ps-0" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "rayon-color-control" }
const _hoisted_10 = {
  class: "rayon-color-palette",
  "aria-label": "Palette de couleurs"
}
const _hoisted_11 = ["title", "onClick"]
const _hoisted_12 = { class: "d-flex align-items-center gap-2 flex-wrap" }
const _hoisted_13 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = {
  key: 0,
  class: "form-check d-flex align-items-center gap-2 ps-0 mb-3"
}
const _hoisted_16 = { class: "d-flex justify-content-end gap-2 mt-3" }
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueInputText = _resolveComponent("PrimevueInputText")!
  const _component_PrimevueInputNumber = _resolveComponent("PrimevueInputNumber")!
  const _component_PrimevueCheckbox = _resolveComponent("PrimevueCheckbox")!
  const _component_PrimevueColorPicker = _resolveComponent("PrimevueColorPicker")!
  const _component_PrimevueTextarea = _resolveComponent("PrimevueTextarea")!
  const _component_AppLoadingButton = _resolveComponent("AppLoadingButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label small fw-semibold" }, "Nom du rayon *", -1)),
        _createVNode(_component_PrimevueInputText, {
          class: "w-100",
          modelValue: _ctx.form.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
          required: ""
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label small fw-semibold" }, "Code", -1)),
        _createVNode(_component_PrimevueInputText, {
          class: "w-100",
          modelValue: _ctx.form.code,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.code) = $event)),
          placeholder: "Ex : R-AB, PARA, DIGI..."
        }, null, 8, ["modelValue"]),
        _cache[11] || (_cache[11] = _createElementVNode("small", { class: "text-muted" }, " Laisser vide pour générer automatiquement. ", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label small fw-semibold" }, "Position", -1)),
        _createVNode(_component_PrimevueInputNumber, {
          class: "w-100",
          min: 0,
          modelValue: _ctx.form.position,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.position) = $event))
        }, null, 8, ["modelValue"]),
        _cache[13] || (_cache[13] = _createElementVNode("small", { class: "text-muted" }, " Ordre dans les listes (0 = par défaut). ", -1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label small fw-semibold" }, "Actif", -1)),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_PrimevueCheckbox, {
            modelValue: _ctx.form.is_active,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.is_active) = $event)),
            binary: "",
            inputId: "rayonActive"
          }, null, 8, ["modelValue"]),
          _cache[14] || (_cache[14] = _createElementVNode("label", {
            class: "form-check-label small",
            for: "rayonActive"
          }, " Disponibles pour l’affectation des produits ", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label small fw-semibold" }, "Couleur du rayon", -1)),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorPalette, (color) => {
            return (_openBlock(), _createElementBlock("button", {
              key: color,
              type: "button",
              class: _normalizeClass(["rayon-color-swatch", { active: _ctx.normalizedColor === color }]),
              style: _normalizeStyle({ backgroundColor: color }),
              title: color,
              onClick: ($event: any) => (_ctx.setColor(color))
            }, null, 14, _hoisted_11))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_PrimevueColorPicker, {
            modelValue: _ctx.colorPickerValue,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.colorPickerValue) = $event)),
            format: "hex"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_PrimevueInputText, {
            modelValue: _ctx.form.color,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.color) = $event)),
            modelModifiers: { trim: true },
            class: "rayon-color-input",
            maxlength: "7",
            placeholder: "#0d9488",
            onBlur: _ctx.normalizeColorField
          }, null, 8, ["modelValue", "onBlur"]),
          _createElementVNode("div", {
            class: "rayon-color-preview",
            style: _normalizeStyle({ borderColor: _ctx.normalizedColor })
          }, [
            _createElementVNode("span", {
              class: "rayon-color-dot",
              style: _normalizeStyle({ backgroundColor: _ctx.normalizedColor })
            }, null, 4),
            _createElementVNode("span", null, _toDisplayString(_ctx.form.name || 'Aperçu du rayon'), 1),
            (_ctx.form.code)
              ? (_openBlock(), _createElementBlock("small", _hoisted_13, "(" + _toDisplayString(_ctx.form.code) + ")", 1))
              : _createCommentVNode("", true)
          ], 4)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label small fw-semibold" }, "Description", -1)),
      _createVNode(_component_PrimevueTextarea, {
        class: "w-100",
        rows: "2",
        modelValue: _ctx.form.description,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.description) = $event)),
        autoResize: "",
        placeholder: "Infos sur le contenu, l’emplacement, type de produits..."
      }, null, 8, ["modelValue"])
    ]),
    (_ctx.mode === 'create')
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(_component_PrimevueCheckbox, {
            modelValue: _ctx.form.create_in_all_shops,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.create_in_all_shops) = $event)),
            binary: "",
            inputId: "rayonCreateInAllShops"
          }, null, 8, ["modelValue"]),
          _cache[18] || (_cache[18] = _createElementVNode("label", {
            class: "form-check-label small",
            for: "rayonCreateInAllShops"
          }, " Créer aussi dans tous les sites actifs ", -1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline-secondary btn-sm",
        disabled: _ctx.submitting,
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('cancel')))
      }, " Annuler ", 8, _hoisted_17),
      _createVNode(_component_AppLoadingButton, {
        type: "button",
        class: "btn btn-primary btn-sm",
        loading: _ctx.submitting,
        "loading-label": "Enregistrement...",
        onClick: _ctx.submit
      }, {
        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
          _createElementVNode("i", { class: "fa fa-save me-1" }, null, -1),
          _createTextVNode(" Enregistrer ", -1)
        ]))]),
        _: 1
      }, 8, ["loading", "onClick"])
    ])
  ]))
}